import styled from "styled-components";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";

export const Card = styled.div`
  background-color: ${colors.background};
  border-radius: ${borderRadius.large}px;
  padding: ${spacing.x3}px;

  @media (max-width: 768px) {
    padding: ${spacing.x1}px;
  }
`;

